import React from 'react';
import { AvGroup } from 'availity-reactstrap-validation';
import { FormattedMessage, injectIntl, useIntl } from 'react-intl';
import { Label } from 'reactstrap';
import PropTypes from 'prop-types';
import {
  getLocaleHierarchy,
  getLocalizedName,
} from '../../../../utility/util/util.service';
import Select, { createFilter } from 'react-select';

const AdditivesField = ({ object, setter, options, isDisabled, ...props }) => {
  // concats all nameXX properties, to be able to search for a name in a different langugage
  // eg. you search for "Salz", it will return Salt, as Salz is german for Salt
  // result search string will be <nameDE>;<nameEN>;...
  const intl = useIntl();
  const stringifyLocalized = (option) =>
    getLocaleHierarchy(intl.locale).reduce(
      (searchString, locale) =>
        searchString + (option.data['name' + locale] || '') + ';',
      '',
    );

  return (
    <AvGroup
      data-testid="additivesField"
      className="react-select form-label-group"
    >
      <Select
        id={object?.id}
        isMulti={true}
        isDisabled={isDisabled}
        delimiter=";"
        name="additives"
        noOptionsMessage={() =>
          intl.formatMessage({ id: 'emptyAdditivesListTitle' })
        }
        className={'react-select-container'}
        classNamePrefix={'react-select'}
        value={object?.additives}
        getOptionLabel={(additive) => getLocalizedName(additive, intl.locale)}
        getOptionValue={(additive) => additive.id}
        onChange={(values) =>
          setter({
            ...object,
            additives: values || [],
            additiveIds: values?.map((additive) => additive.id) || [],
          })
        }
        filterOption={createFilter({ stringify: stringifyLocalized })}
        placeholder={intl.formatMessage({ id: 'selectAdditivesLabel' })}
        options={options}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 }),
        }}
        {...props}
      />
      <Label className="floating-label" for={object?.id}>
        <FormattedMessage id="additivesTitle" />
      </Label>
    </AvGroup>
  );
};

AdditivesField.propTypes = {
  object: PropTypes.object,
  setter: PropTypes.func,
  options: PropTypes.array,
  isDisabled: PropTypes.bool,
};

export default AdditivesField;
